module.exports = __webpack_public_path__ + "static/media/04.38e07bc5.png";